const isIE = /* @cc_on!@ */false || !!document.documentMode;

const browserCheck = { isIE };
export default browserCheck;
